import type { Product } from '~/types/Product'
import type { Vehicle } from '~/types/Vehicle'

export const useProduct = () => {
  const isProductCompatibleWithVehicle = (product: Product, vehicle: Vehicle): boolean => {
    if (vehicle.isGroup) {
      const key: keyof Vehicle = 'vehicle_models' in vehicle ? 'vehicle_models' : 'vehicleModels'

      return product.compatible_vehicle_models.some((productVehicleModel: { id: string }) =>
        vehicle?.[key]?.some(vehicleModel => vehicleModel.id === productVehicleModel.id)
      )
    }

    return product.compatible_vehicle_models.some((productVehicleModel: { id: string }) =>
      productVehicleModel.id === vehicle.id
    )
  }

  const isProductIncludedByDefault = (product: Product): boolean =>
    Boolean(product.included_by_default)

  const isProductOneTime = (product: Product): boolean =>
    product.type === 'one_time'

  return {
    isProductOneTime,
    isProductIncludedByDefault,
    isProductCompatibleWithVehicle
  }
}
